import React, { useState } from "react";
import {
  Box,
  Textarea,
  Button,
  Text,
  Heading,
  Flex,
  Input,
  Image,
} from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import Logo from "../assets/images/drhvac.svg";
import { submitFeedback } from "../utils/api"; // Import the reusable API function

const FeedbackForm = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || ""; // Extract email from URL
  const rating = searchParams.get("rating") || ""; // Extract rating from URL
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(""); // For handling errors
  const [contact, setContact] = useState();

  console.log("Submitting Feedback:", {
    email,
    name,
    phoneNumber,
    comment,
    contact,
  });

  console.log("Received Email:", email);
  console.log("Received Rating:", rating);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const feedbackData = {
        email,
        name,
        phoneNumber,
        comment,
        contact,
        rating, // ✅ Ensure rating is sent
      };

      console.log("Submitting Feedback:", feedbackData);
      const feedbackMessage = await submitFeedback(feedbackData);

      setMessage(feedbackMessage);
      setError("");
      setComment("");
      setName("");
      setPhoneNumber("");
      setContact("");
    } catch (err) {
      setError(err.message || "Failed to submit feedback. Please try again.");
      setMessage("");
    }
  };

  return (
    <Flex
      height="100vh"
      justifyContent="center"
      alignItems="center"
      bg="gray.50"
      padding="20px"
    >
      <Box
        as="form"
        onSubmit={handleSubmit}
        bg="white"
        p={8}
        rounded="lg"
        boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)" // Floating effect
        w={{ base: "90%", sm: "400px" }}
        textAlign="center"
      >
        <Image w={100} src={Logo} />
        <Heading as="h2" size="md" m={4} color="#1c4b7e" textAlign={"center"}>
          We Value Your Feedback
        </Heading>
        <Input
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          mb={4}
          size="lg"
          border="2px"
          borderColor="gray.300"
          _hover={{ borderColor: "#0078D7" }}
          _focus={{
            borderColor: "#0078D7",
            boxShadow: "0px 4px 10px rgba(0, 120, 215, 0.6)",
          }}
          rounded="md"
        />
        <Input
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          mb={4}
          type="number"
          size="lg"
          border="2px"
          borderColor="gray.300"
          _hover={{ borderColor: "#0078D7" }}
          _focus={{
            borderColor: "#0078D7",
            boxShadow: "0px 4px 10px rgba(0, 120, 215, 0.6)",
          }}
          rounded="md"
        />
        <Textarea
          placeholder="Please tell us how we can improve..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          mb={4}
          size="lg"
          border="2px"
          borderColor="gray.300"
          _hover={{ borderColor: "#0078D7" }}
          _focus={{
            borderColor: "#0078D7",
            boxShadow: "0px 4px 10px rgba(0, 120, 215, 0.6)",
          }}
          rounded="md"
        />
        <div>
          <Text mb={2}>Would you like to be contacted?</Text>
          <Flex justifyContent="center" mb={4}>
            <label>
              <input
                type="radio"
                name="contact"
                value="yes"
                checked={contact === "yes"}
                onChange={(e) => setContact(e.target.value)}
              />
              Yes
            </label>
            <label style={{ marginLeft: "20px" }}>
              <input
                type="radio"
                name="contact"
                value="no"
                checked={contact === "no"}
                onChange={(e) => setContact(e.target.value)}
              />
              No
            </label>
          </Flex>
        </div>

        <Button
          mt={6}
          bg="#00aeef"
          color="white"
          _hover={{ bg: "#1c4b7e" }}
          _focus={{
            boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
          }}
          _active={{
            bg: "#1c4b7e",
            transform: "scale(0.98)",
          }}
          w="full"
          type="submit"
        >
          Submit Feedback
        </Button>
        {message && (
          <Text mt={4} color="green.500">
            {message}
          </Text>
        )}
      </Box>
    </Flex>
  );
};

export default FeedbackForm;
